module.exports = __webpack_public_path__ + "static/media/portland.ce08b3cd.webp";